import { IRoutingService } from '@components-common/routes';
import { useContainer } from './use-container.hook';

export const useRouting = () => {
  const container = useContainer();
  const routingService = container.resolve<IRoutingService>('routing-service');
  return routingService;
};

export const useActiveRoute = () => {
  const service = useRouting();
  return service.getActiveRoute();
};
